export let DataHook = /*#__PURE__*/function (DataHook) {
  DataHook["root"] = "consent-banner-root";
  DataHook["description"] = "consent-banner-description";
  DataHook["buttons"] = "consent-banner-buttons";
  DataHook["viewPolicyLink"] = "consent-banner-view-policy-link";
  DataHook["settingsButton"] = "consent-banner-settings-button";
  DataHook["acceptPolicyButton"] = "consent-banner-apply-button";
  DataHook["declineAllButton"] = "consent-banner-decline-all-button";
  DataHook["settingsDialog"] = "consent-banner-settings-dialog";
  DataHook["closeButton"] = "consent-banner-close-button";
  DataHook["sectionComponentRoot"] = "consent-banner-section-root";
  DataHook["sectionComponentTitle"] = "consent-banner-section-title";
  DataHook["sectionComponentDescription"] = "consent-banner-section-description";
  DataHook["sectionComponentToggle"] = "consent-banner-section-toggle";
  DataHook["sectionComponentToggleInput"] = "consent-banner-section-toggle-input";
  DataHook["settingsContainer"] = "consent-banner-settings-container";
  DataHook["settingsSaveButton"] = "consent-banner-settings-save-button";
  DataHook["revisitSettingsContainer"] = "consent-banner-revisit-settings-container";
  DataHook["revisitSettingsButton"] = "consent-banner-revisit-settings-button";
  DataHook["revisitSettingsButtonText"] = "consent-banner-revisit-settings-button-text";
  DataHook["revisitSettingsCloseButton"] = "consent-banner-revisit-settings-close-button";
  return DataHook;
}({});
//# sourceMappingURL=data-hooks.js.map